import './styles/App.css';
import './styles/gallery.css'
import React from 'react'
import { ethers, logger } from 'ethers';
import { useState , useEffect} from 'react';
import connector from './utils.js'
import {Link} from 'react-router-dom';
import Button from '@mui/material/Button';

function Present(props) {
  const [contract, setContract]=useState('undefined');
  const [signer,setSigner] = useState('');
  const [provider,setProvider] = useState('');
  const [accounts,setAccounts] = useState([]);
  const [presents,setPresents] = useState(undefined);
  const [reviews,setReviews] = useState([]);
  async function getPresents (){
    var id = await window.location.pathname[1]
    var pres = await contract.connect(signer).idToPresent(id); 
    setPresents(pres);
  }
  
  useEffect(() => {
    const init = async()=>{
    const lis = await connector(props.address);
    if (contract=='undefined'){
      setContract(await lis.contract);
    }
    setProvider(await lis.provider);
    setAccounts(await lis.accounts);
    setSigner(await lis.signer);
    }
    init();
    getPresents();
  },[contract]);

  useEffect(() => {
    const getRevs = async()=>{
      if(presents!=undefined){
        var revs=[]
        var id = await window.location.pathname[1]
        const numRevs = Number(presents.numRevs)
        for (var i =0; i<numRevs;i++){
          var rev = await contract.connect(signer).idToReviews(id,i); 
          revs.push(rev)
        }
      setReviews(revs)
      }
    }
    getRevs()
  },[presents])
  function trial (){
    if(presents!=undefined){
        let stas =[]
        let pr = presents
        let label =  `$${pr.price}`
        let gender;
        if(pr.gender == 1){
          gender = "♀"
        }
        if(pr.gender == 2){
          gender = "♂"
        }
        if(pr.gender == 3){
          gender = "⚥"
        }
        let rating = `${pr.rating}`
        let age = `${pr.age}`
        stas.push(
        <div className='gallery'>
            <img className='image-main' src= {pr.photo} ></img>
            <div>
              <p id ='itemDesc' className='myst'>Category: {pr.category}</p>
              <p id ="itemName" className='myst'>{pr.name}</p>
              <p id ="itemName" className='myst'>{label}</p>
              <p id ="itemDesc" className='myst'>{pr.desc}</p>

              <br/>
              <div className='grid'>
              <div >
                <p id ="heading" className='myst spec'>Specifiactions : </p>
                <p id ="itemDesc" className='myst spec'>AGE: {age}</p>
                <p id ="itemDesc" className='myst spec' >GENDER: {gender}</p>
                <p id ="itemDesc" className='myst spec'>RATING: {rating/10} ⭐</p>
                <br/>
                <p><br/></p>
                <br/>
                <a id = "itemName" className='myst' href={pr.link}>GO TO LINK</a>

              </div>
              <div >
                {displayRevs()}
              </div>
              </div>
              
            </div>
        </div>
        )
        return(stas)
        }
  }
  
  
  async function handleSubmit (event) {
    event.preventDefault()    
    const ob = ind =>{
      return(event.target[ind].value)
    }
    const ad = (await signer.getAddress())
    var id = await window.location.pathname[1]
    contract.connect(signer).review(id,ob(0)*10,ob(1));
    //contract.connect(signer).review(id,46,"Really Happy with this cup. My mom gifted it to me and I have been using it regualrly");
  }
  function displayRevs (){
    var items =[]
    for (var i=0; i<reviews.length;i++){
      var r = (reviews[i]);
      var newAd;
      if (r.reviewer.length > 10){
        newAd = `● ${(r.reviewer.substring(0,10))}...                ${(r.rating)/10}⭐`
      }
      items.push(
        <div id ="rev" className='rev'> 
          <pre id ="itemDesc" className='myst'>{newAd}</pre>
          <p  id ="itemDesc" className='myst'>{r.review}</p>
        </div>
      )
    }
    return(items)
    }
  
  return (
    <div className='App'>
        <nav>
      <div className='linkButton' id ='linkbutton'>
        <Link to ="/" id="homeLink" className='homelink'></Link>
        <Link to ="/" id="logo"></Link>      
        <Link to="/add" id = "addLink">
          <button id = 'addButt'>ADD PRESENT</button>
        </Link>  
        <Link to="/profile" id = "profLink">
          <button id = 'profButt'>PROFILE</button>
        </Link>  
      </div>
    </nav>
        <div id = "gridDesign" >
            {trial()}
        </div>
        <div>
          <p id ="heading" className='spec'>ADD REVIEW</p>
        </div>
        <div>
          <form onSubmit={handleSubmit}>
          <input
                type='number'
                step="0.1"
                min='0'
                max='20'
                placeholder='rating' 
                id = "rating"
              />
            <input type="text" placeholder='review' id = "review"></input>
            <Button variant="contained" color="primary" type="submit">SUBMIT</Button>
          </form>
        </div>
        
    </div>
  );
}
export default Present
